<template>
    <div class="sticky">{{ $t('You have unfinished rounds!') }} <button class="btn btn-open_game" @click="openGame(openRoundGameId)">{{ $t('Open game') }}</button></div>
</template>
<script>
export default {
    name: "InfoBox",
    props: {
        openRoundGameId: Number
    },
    methods: {
        openGame(openRoundGameId) {
            this.$emit('openGame', openRoundGameId);
        }
    }
}
</script>

<style scoped lang="scss">
div.sticky {
    position: sticky;
    top: 64px;
    background-color: yellow;
    font-size: 20px;
    z-index: 14;
    text-align: center;
    width: 84%;
    margin: auto auto 20px;
    border-radius: 5px;
}

.btn-open_game {
   background-image: linear-gradient(92.88deg, #455EB5 9.16%, #5643CC 43.89%, #673FD7 64.72%);
   border-radius: 5px;
   color: #FFFFFF;
   cursor: pointer;
   font-size: 16px;
   padding: 0 10px;
   text-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px;
   transition: all .5s;
   margin-left: 5px;
}

.btn-open_game:hover {
    box-shadow: rgba(80, 63, 205, 0.5) 0 1px 15px;
    transition-duration: .1s;
}
</style>
